export const titles = [
  'Date',
  'From',
  'To',
  'Wholesale Cost',
  'LTL Price',
  'LTL Invoice #',
  'Status',
  'Created By',
];
